import "../scss/main.scss";

// ── Lightbox ──
window.openLightbox = function (el) {
  var src = el.querySelector("img").src;
  document.getElementById("lightbox-img").src = src;
  document.getElementById("lightbox").classList.add("open");
  document.body.style.overflow = "hidden";
};

window.closeLightbox = function () {
  document.getElementById("lightbox").classList.remove("open");
  document.body.style.overflow = "";
};

// ── Video Lightbox ──
window.openVideoLightbox = function (id) {
  document.getElementById("video-lightbox-iframe").src =
    "https://www.youtube.com/embed/" + id + "?autoplay=1";
  document.getElementById("video-lightbox").classList.add("open");
  document.body.style.overflow = "hidden";
};

window.closeVideoLightbox = function () {
  document.getElementById("video-lightbox-iframe").src = "";
  document.getElementById("video-lightbox").classList.remove("open");
  document.body.style.overflow = "";
};

// ── Escape key handler ──
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    window.closeLightbox();
    if (document.getElementById("video-lightbox")) {
      window.closeVideoLightbox();
    }
  }
});

// ── Sticky nav scroll effect ──
var header = document.getElementById("header");

window.addEventListener(
  "scroll",
  function () {
    if (window.scrollY > 60) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  },
  {
    passive: true,
  },
);

// ── Mobile nav toggle ──
var navToggle = document.getElementById("navToggle");
var mainNav = document.getElementById("mainNav");

navToggle.addEventListener("click", function () {
  navToggle.classList.toggle("open");
  mainNav.classList.toggle("open");
});

mainNav.querySelectorAll("a").forEach(function (a) {
  a.addEventListener("click", function () {
    navToggle.classList.remove("open");
    mainNav.classList.remove("open");
  });
});

// ── Active nav highlight on scroll (home only) ──
var sections = document.querySelectorAll("section[id]");

if (sections.length > 0) {
  var navLinks = mainNav.querySelectorAll("a");

  window.addEventListener(
    "scroll",
    function () {
      var scrollY = window.scrollY + 120;
      sections.forEach(function (section) {
        var top = section.offsetTop;
        var height = section.offsetHeight;
        var id = section.getAttribute("id");
        if (scrollY >= top && scrollY < top + height) {
          navLinks.forEach(function (link) {
            link.classList.remove("active");
            if (link.getAttribute("href") === "#" + id) {
              link.classList.add("active");
            }
          });
        }
      });
    },
    {
      passive: true,
    },
  );
}

// ── Scroll fade-in animations ──
var fadeEls = document.querySelectorAll(".fade-in");

if (fadeEls.length > 0) {
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = 0;
          var parent = entry.target.parentElement;
          if (parent) {
            var siblings = parent.querySelectorAll(".fade-in");
            siblings.forEach(function (sib, idx) {
              if (sib === entry.target) delay = idx * 80;
            });
          }
          setTimeout(function () {
            entry.target.classList.add("visible");
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -40px 0px",
    },
  );

  fadeEls.forEach(function (el) {
    observer.observe(el);
  });
}
